import React from "react";
import { Grid, TextField, MenuItem, Input, Menu } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EnumChangeName from "../common/EnumChangeName";
import { convertUtcToTzIsoDayJs } from "../../../../util/timezoneConversion";


const TabPanel1 = ({ data, setEditVehicle, editVehicle, tireType }: any) => {
  const { t } = useTranslation(["operation"]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const enumName = EnumChangeName();

  //console.log("data in tabpanel1 LB", data);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  let status = data.statusReasons[0]?.code;
  let statusReasons = data.statusReasons?.splice(1);

  const handleChange = (e: any) => {
    setEditVehicle({ ...editVehicle, [e.target.name]: e.target.value });
  };

  const ownershipLabel =
    data.ownership === "LEASYS"
      ? t("vehicle.tabPanel1.ownership_leasys")
      : t("vehicle.tabPanel1.ownership_no_leasys");

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="vin"
          name="vin"
          label={t("carMaintenance.filterAndSearch.vin")}
          value={data.vin}
          size="small"
        />
        <TextField
          fullWidth
          disabled
          id="plate"
          name="plate"
          label={t("carMaintenance.filterAndSearch.plate")}
          value={data.plate}
        />
        <DatePicker
          label={t("vehicle.tabPanel1.saleDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.expectedSaleDate ? data.expectedSaleDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="ownership"
          name="ownership"
          label={t("vehicle.tabPanel1.ownership")}
          value={ownershipLabel}
        />
        <TextField
          fullWidth
          disabled
          id="ownerCode"
          name="ownerCode"
          label={t("vehicle.tabPanel1.ownerCode")}
          value={data.ownerCode}
        />
        <TextField
          fullWidth
          disabled
          id="ownerDescr"
          name="ownerDescr"
          label={t("vehicle.tabPanel1.ownerDescription")}
          value={data.ownerDescr}
        />
        <TextField
          fullWidth
          disabled
          id="internalNumber"
          name="internalNumber"
          label={t("vehicle.tabPanel1.internalNumber")}
          value={data.internalNumber}
        />
        <TextField
          fullWidth
          disabled
          id="duration"
          name="duration"
          label={t("vehicle.tabPanel1.duration")}
          value={data.duration}
        />
        <TextField
          fullWidth
          disabled
          id="vehicleStatusReasons"
          name="vehicleStatusReasons"
          label={t("vehicle.tabPanel1.vehicleStatusReasons")}
          value={status}
          InputProps={{
            endAdornment:
              statusReasons.length > 1 ? (
                <MoreVertIcon onClick={handleClick} />
              ) : (
                ""
              ),
          }}
        />
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {statusReasons.map((status: any) => (
            <MenuItem>{status.code}</MenuItem>
          ))}
        </Menu>
        <TextField
          fullWidth
          disabled
          id="vehicleType"
          name="vehicleType"
          label={t("vehicle.tabPanel1.vehicleType")}
          value={data.vehicleType}
        />
        <TextField
          fullWidth
          disabled
          id="vehicleTypeDescr"
          name="vehicleTypeDescr"
          label={t("vehicle.tabPanel1.vehicleTypeDescr")}
          value={data.vehicleTypeDescr}
        />
        <TextField
          fullWidth
          disabled
          id="importType"
          name="importType"
          label={t("vehicle.tabPanel1.importType")}
          value={data.importType}
        />
        <DatePicker
          label={t("vehicle.tabPanel1.updateDate")}
          disabled
          inputFormat="DD-MM-YYYY HH:mm"
          value={!!data.updateDatetime ? convertUtcToTzIsoDayJs(data.updateDatetime, data.timeZoneId) : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="firstFuelingDone"
          name="firstFuelingDone"
          label={t("vehicle.tabPanel1.firstFuelingDone")}
          value={data.firstFuelingDone}
        />        
        <TextField
          fullWidth
          disabled
          id="tsPackageCode"
          name="tsPackageCode"
          label={t("vehicle.tabPanel1.tsPackageCode")}
          value={data.tsPackageCode}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="brand"
          name="brand"
          label={t("vehicle.brand")}
          value={data?.model?.brand?.descr}
        />
        <TextField
          fullWidth
          disabled
          id="model"
          name="model"
          label={t("vehicle.model")}
          value={data?.model?.descr}
        />
        <TextField
          fullWidth
          disabled
          id="carRangeDescription"
          name="carRangeDescription"
          label={t("vehicle.tabPanel1.carRangeDescription")}
          value={data.carRange.descr}
        />
        <TextField
          fullWidth
          disabled
          id="carRangeCode"
          name="carRangeCode"
          label={t("vehicle.tabPanel1.carRangeCode")}
          value={data.carRange.code}
        />
        <TextField
          fullWidth
          disabled
          id="series"
          name="series"
          label={t("vehicle.tabPanel1.series")}
          value={data.series}
        />
        <TextField
          fullWidth
          disabled
          id="outfittingDescription"
          name="outfittingDescription"
          label={t("outfitting.description")}
          value={data.outfitting.descr}
        />
        <TextField
          fullWidth
          disabled
          id="outfittingCode"
          name="outfittingCode"
          label={t("outfitting.code")}
          value={data.outfitting.code}
        />
        <DatePicker
          label={t("vehicle.tabPanel1.estimatedDeliveryDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={
            !!data.estimatedDeliveryDate ? data.estimatedDeliveryDate : null
          }
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="operativeCenterEstimatedDeliveryDescription"
          name="operativeCenterEstimatedDeliveryDescription"
          label={t(
            "vehicle.tabPanel1.operativeCenterEstimatedDeliveryDescription"
          )}
          value={data.operativeCenterEstimatedDeliveryDescription}
        />

        <TextField
          fullWidth
          disabled
          id="operativeCenterEstimatedDeliveryType"
          name="operativeCenterEstimatedDeliveryType"
          label={t("vehicle.tabPanel1.operativeCenterEstimatedDeliveryType")}
          value={EnumChangeName().locationType(
            data.operativeCenterEstimatedDeliveryType
          )}
        />
        <TextField
          fullWidth
          disabled
          id="operativeCenterEstimatedDeliverySapId"
          name="operativeCenterEstimatedDeliverySapId"
          label={t("vehicle.tabPanel1.operativeCenterEstimatedDeliverySapId")}
          value={data.operativeCenterEstimatedDeliveryId}
        />
        <TextField
          fullWidth
          disabled
          id="operativeCenterEstimatedDeliveryTypeDescription"
          name="operativeCenterEstimatedDeliveryTypeDescription"
          label={t(
            "vehicle.tabPanel1.operativeCenterEstimatedDeliveryTypeDescription"
          )}
          value={data.operativeCenterEstimatedDeliveryTypeDescription}
        />

        <DatePicker
          label={t("vehicle.tabPanel1.importDate")}
          disabled
          inputFormat="DD-MM-YYYY HH:mm"
          value={!!data.createDatetime ? convertUtcToTzIsoDayJs(data.createDatetime, data.timeZoneId) : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <DatePicker
          label={t("vehicle.tabPanel1.fleetExitDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.fleetExitDate ? data.fleetExitDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />        
        <TextField
          fullWidth
          disabled
          id="tsSupplier"
          name="tsSupplier"
          label={t("vehicle.tabPanel1.tsSupplier")}
          value={data.tsSupplier}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="carSegment"
          name="carSegment"
          label={t("vehicle.tabPanel1.carSegment")}
          value={data.carClass.carSegment.descr}
        />
        <TextField
          fullWidth
          disabled
          id="carClass"
          name="carClass"
          label={t("availabilityReport.carClassLabel")}
          value={data.carClass.descr}
        />
        <TextField
          fullWidth
          disabled
          id="acriss"
          name="acriss"
          label={t("vehicle.tabPanel1.acriss")}
          value={data.acriss.code}
        />
        <TextField
          fullWidth
          disabled
          id="acriss"
          name="acriss"
          label={t("vehicle.tabPanel1.acrissLabel")}
          value={data.acriss.label}
        />
        <TextField
          fullWidth
          disabled
          id="acriss"
          name="acriss"
          label={t("vehicle.tabPanel1.acrissVehicleType")}
          value={data.acriss.vehicleType}
        />
        <TextField
          fullWidth
          disabled
          id="sipp"
          name="sipp"
          label={t("vehicle.sipp")}
          value={data.customAcriss?.code || ""}
        />
        <TextField
          fullWidth
          disabled
          id="sippLabel"
          name="sippLabel"
          label={t("vehicle.tabPanel1.sippLabel")}
          value={data.customAcriss?.label || ""}
        />
        <TextField
          fullWidth
          disabled
          id="sippKeyless"
          name="sippKeyless"
          label={t("vehicle.tabPanel1.sippKeyless")}
          value={
            enumName.yesNoType(data.customAcriss?.keyless?.toString()) || ""
          }
        />
        <DatePicker
          label={t("vehicle.tabPanel1.realDeliveryDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.realDeliveryDate ? data.realDeliveryDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="operativeCenterRealDeliveryDescription"
          name="operativeCenterRealDeliveryDescription"
          label={t("vehicle.tabPanel1.operativeCenterRealDeliveryDescr")}
          value={data.operativeCenterRealDeliveryDescription}
        />
        <TextField
          fullWidth
          disabled
          id="operativeCenterRealDeliveryType"
          name="operativeCenterRealDeliveryType"
          label={t("vehicle.tabPanel1.operativeCenterRealDeliveryType")}
          value={EnumChangeName().locationType(
            data.operativeCenterRealDeliveryType
          )}
        />

        <TextField
          fullWidth
          disabled
          id="operativeCenterRealDeliverySapId"
          name="operativeCenterRealDeliverySapId"
          label={t("vehicle.tabPanel1.operativeCenterRealDeliverySapId")}
          value={data.operativeCenterRealDeliveryId}
        />
        <TextField
          fullWidth
          disabled
          id="businessLine"
          name="businessLine"
          label={t("vehicle.tabPanel1.businessLine")}
          value={data.businessLine}
        />        
        <TextField
          fullWidth
          disabled
          id="tsServices"
          name="tsServices"
          label={t("vehicle.tabPanel1.tsServices")}
          value={data.tsServices}
        />
        <TextField
          fullWidth
          disabled
          id="tsVoucher"
          name="tsVoucher"
          label={t("vehicle.tabPanel1.tsVoucher")}
          value={data.tsVoucher}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="imeiPrimary"
          name="imeiPrimary"
          label={t("vehicle.tabPanel1.imeiPrimary")}
          value={data.imeiPrimary}
        />
        <TextField
          fullWidth
          disabled
          variant="standard"
          key="imeiSecondary"
          name="imeiSecondary"
          label={t("vehicle.tabPanel1.imeiSecondary")}
          value={editVehicle.imeiSecondary || ""}
        />
        <TextField
          disabled
          type="text"
          label={t("vehicle.tabPanel1.currentTireTypeDescr")}
          name="currentTireTypeDescr"
          value={data.currentTireTypeDescr}
          fullWidth
        />
        <TextField
          disabled
          type="text"
          label={t("vehicle.tabPanel1.currentTireType")}
          name="currentTireType"
          value={data.currentTireType}
          fullWidth
        />
        <TextField
          fullWidth
          disabled
          id="tireSizeFront"
          name="tireSizeFront"
          label={t("vehicle.tabPanel2.tireSizeFront")}
          value={data.tireSizeFront}
        />
        <TextField
          fullWidth
          disabled
          id="tireSizeRear"
          name="tireSizeRear"
          label={t("vehicle.tabPanel2.tireSizeRear")}
          value={data.tireSizeRear}
        />
        <TextField
          fullWidth
          variant="standard"
          key="kmMaintenance"
          name="kmMaintenance"
          label={t("vehicle.tabPanel1.kmMaintenance")}
          value={`${editVehicle.kmMaintenance}` || ""}
          disabled
        />
        <TextField
          fullWidth
          variant="standard"
          key="maintenancePeriod"
          name="maintenancePeriod"
          label={t("vehicle.tabPanel1.maintenancePeriod")}
          value={`${editVehicle.maintenancePeriod}` || ""}
          disabled
        />

        <TextField
          fullWidth
          disabled
          id="loadIndex"
          name="loadIndex"
          label={t("vehicle.tabPanel1.loadIndex")}
          value={data.loadIndex.toFixed(1)}
        ></TextField>
        <DatePicker
          label={t("vehicle.tabPanel1.lastMaintenanceDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={
            !!data.lastMaintenance?.maintenanceDate
              ? data.lastMaintenance?.maintenanceDate
              : null
          }
          onChange={() => ""}
          renderInput={(params) => (
            <TextField {...params} error={false} fullWidth />
          )}
        />

        <TextField
          fullWidth
          disabled
          id="vehicleStatus"
          name="vehicleStatus"
          label={t("vehicle.tabPanel1.vehicleStatus")}
          value={
            data.vehicleStatus === "AVAILABLE"
              ? t("internOptionSelectName.available")
              : t("internOptionSelectName.notAvailable")
          }
        />
        <TextField
          fullWidth
          disabled
          id="sapVehicleStatus"
          name="sapVehicleStatus"
          label={t("vehicle.tabPanel1.sapVehicleStatus")}
          value={data.sapVehicleStatus}
        />
        <TextField
          fullWidth
          disabled
          id="businessLineDescr"
          name="businessLineDescr"
          label={t("vehicle.tabPanel1.businessLineDescr")}
          value={data.businessLineDescr}
        />

        <TextField
          fullWidth
          disabled
          id="tsBusinessServices"
          name="tsBusinessServices"
          label={t("vehicle.tabPanel1.tsBusinessServices")}
          value={data.tsBusinessServices}
        />
      </Grid>
    </Grid>
  );
};
export default TabPanel1;
